import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  Pagination,
  Tag,
  Button,
  TextInput
} from "@carbon/react";
import { Edit, Checkmark, Close, Building } from "@carbon/icons-react";

const getVerificationTagType = (status = "") => {
  const value = status.toLowerCase().replace(/_/g, " ").trim();

  switch (value) {
    case "draft":
      return "purple";

    case "pending":
      return "red";

    case "under verification":
      return "yellow";

    case "verified":
      return " blue";
    
    case "active".toLowerCase():
      return "green";
    case "SoldOut".toLowerCase():
      return "red";

    default:
      return "cool-gray";
  }
};
const getPropertyTypeColor = (type = "") => {
  switch (type.toLowerCase().trim()) {
    case "residential":
      return "#4bae69"; // Green

    case "commercial":
      return "#80A8FF"; // Purple

    case "land/plot":
      return "#e86c6c"; // Orange

    default:
      return "#525252";
  }
};
export default function PropertyTable({
  headers,
  rows,
  loading,
//   formatDate,
  renderActionsForRow,
  totalItems,
  page,
  pageSize,
  setPage,
  setPageSize,
  editingTitleId,
  editingTitle,
  setEditingTitle,
  savingTitle,
  handleEditTitle,
  handleSaveTitle,
  handleCancelTitleEdit
}) {

  if (loading) {
    return <p style={{ padding: "1rem" }}>Loading properties...</p>;
  }

  return (
    <>
    
      <Table>
<TableHead>
  <TableRow>
    {headers.map((h) => (
      <TableHeader
        key={h.key}
        isSortable={false}
        style={{
          position: "sticky",
          top: 0,
          zIndex: 3,
          backgroundColor: "#f4f4f4",   // opaque so rows don't bleed through
          boxShadow: "inset 0 -1px 0 0 #e0e0e0",
        }}
      >
        {h.header}
      </TableHeader>
    ))}
  </TableRow>
</TableHead>

<TableBody>
  {rows.length === 0 ? (
    <TableRow>
      <TableCell
        colSpan={headers.length}
        style={{
          textAlign: "center",
          padding: "2rem"
        }}
      >
        No properties found
        <br />
        <span
          style={{
            fontSize: "12px",
            color: "#6f6f6f"
          }}
        >
          Try adjusting filters or search keyword
        </span>
      </TableCell>
    </TableRow>
  ) : (
    rows.map((row, index) => (
      <TableRow key={`${row.id}-${row.uuid}-${index}`}>
        {headers.map((header) => {
          switch (header.key) {
case "sequenceID":
  return (
    <TableCell
      key={header.key}
      style={{ textAlign: "left" }}          // Keeps the column alignment left
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",    // 👈 Pushes items to opposite ends
          gap: "8px",
        }}
      >
        {/* 1. Text comes first (left) */}
        <span>{row.sequenceID}</span>
        
        {/* 2. Icon comes second (right) */}
        {row.isBuilderPosted && (
          <Building
            size={20}
            title="Posted by Builder"
            style={{
              fill: "#0f62fe",
              stroke: "#0f62fe",
              strokeWidth: 1.5,
              flexShrink: 0,
            }}
          />
        )}
      </div>
    </TableCell>
  );
            case "propertyTitle":
              return (
                <TableCell key={header.key}>
                  {editingTitleId === row.id ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        minWidth: "250px",
                      }}
                    >
                      <TextInput
                        id={`property-title-${row.id}`}
                        labelText=""
                        hideLabel
                        size="sm"
                        value={editingTitle}
                        onChange={(e) =>
                          setEditingTitle(e.target.value)
                        }
                        disabled={savingTitle}
                      />

                      <Button
                        kind="ghost"
                        size="sm"
                        hasIconOnly
                        renderIcon={Checkmark}
                        iconDescription="Save title"
                        onClick={() => handleSaveTitle(row)}
                        disabled={savingTitle}
                      />

                      <Button
                        kind="ghost"
                        size="sm"
                        hasIconOnly
                        renderIcon={Close}
                        iconDescription="Cancel"
                        onClick={handleCancelTitleEdit}
                        disabled={savingTitle}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <span>
                        {row.propertyTitle || "-"}
                      </span>

                      <Button
                        kind="ghost"
                        size="sm"
                        hasIconOnly
                        renderIcon={Edit}
                        iconDescription="Edit property title"
                        onClick={() => handleEditTitle(row)}
                      />
                    </div>
                  )}
                </TableCell>
              );

case "postedType":
  return (
    <TableCell key={header.key}>
      <span
        style={{
          color: getPropertyTypeColor(row.postedType),
          fontWeight: 600,
          fontSize: "14px",
        }}
      >
        {row.postedType} {row.postedFor}
      </span>
    </TableCell>
  );

            case "postedBy":
              return (
                <TableCell key={header.key}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "4px"
                    }}
                  >
                    <span>{row.postedBy || "-"}</span>

                    {row.ownerNumber && (
                      <Tag size="sm" type="cyan">
                        {row.ownerNumber}
                      </Tag>
                    )}
                  </div>
                </TableCell>
              );

            case "priceInfo":
              return (
                <TableCell key={header.key}>
                  {row.priceInfo || "-"}
                </TableCell>
              );

            case "tag":
              return (
                <TableCell key={header.key}>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "4px"
                    }}
                  >
                    {Array.isArray(row.tag) ? (
                      row.tag.filter(
                        (t) => t && t.trim() !== ""
                      ).length > 0 ? (
                        row.tag
                          .filter(
                            (t) => t && t.trim() !== ""
                          )
                          .map((t, i) => (
                            <Tag
                              key={`${row.id}-tag-${i}`}
                              type="blue"
                            >
                              {t}
                            </Tag>
                          ))
                      ) : (
                        <Tag type="cool-gray">N/A</Tag>
                      )
                    ) : row.tag &&
                      row.tag.trim() !== "" ? (
                      <Tag type="blue">
                        {row.tag}
                      </Tag>
                    ) : (
                      <Tag type="cool-gray">
                        N/A
                      </Tag>
                    )}
                  </div>
                </TableCell>
              );

            case "location":
              return (
                <TableCell key={header.key}>
                  {row.location}
                </TableCell>
              );

            case "verificationStatus":
              return (
                <TableCell key={header.key}>
                  <Tag
                    type={getVerificationTagType(
                      row.verificationStatus
                    )}
                  >
                    {row.verificationStatus}
                  </Tag>
                </TableCell>
              );

            case "verifiedBy":
              return (
                <TableCell key={header.key}>
                  {row.verifiedBy}
                </TableCell>
              );

            case "verifiedDate":
              return (
                <TableCell key={header.key}>
                  {row.verifiedDate}
                </TableCell>
              );

            case "status":
              return (
                <TableCell key={header.key}>
                  <Tag
                    type={getVerificationTagType(row.status)}
                  >
                    {row.status}
                  </Tag>
                </TableCell>
              );

            case "createdBy":
              return (
                <TableCell key={header.key}>
                  {row.createdBy}
                </TableCell>
              );

            case "createdAt":
              return (
                <TableCell key={header.key}>
                  {row.createdAt}
                </TableCell>
              );

            case "actions":
              return (
                <TableCell key={header.key}>
                  {renderActionsForRow(row.id)}
                </TableCell>
              );

            default:
              return (
                <TableCell key={header.key}>
                  {row[header.key] ?? "-"}
                </TableCell>
              );
          }
        })}
      </TableRow>
    ))
  )}
</TableBody>
      </Table>
    

      {totalItems > 0 && (
        <div style={{ padding: "1rem 1.25rem", display: "flex", justifyContent: "flex-end" }}>
          <Pagination
            totalItems={totalItems}
            page={page}
            pageSize={pageSize}
            pageSizes={[5, 10, 20, 50]}
            onChange={({ page: p, pageSize: ps }) => {
              setPage(p);
              setPageSize(ps);
            }}
          />
        </div>
      )}
    </>
  );
}